import { Deserializable } from './deserializable';
import { NavEntity } from './nav-entity';

export class Customer implements Deserializable, NavEntity {
    id: number;
    address: string;
    city: string;
    company: string;
    country: string;
    postalCode: string;
    salesForceCustomerId: string;
    state: string;

    isFavorite = false;

    deserialize(input: any): any {
        Object.assign(this, input);
        return this;
    }

    getName(): string {
        return this.company;
    }

    getType(): 'customer' | 'site' | 'train' {
        return 'customer';
    }

    getId(): number {
        return this.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/customer.ts